import  { useState, useEffect } from "react";

function usePricelist(){
    const [pricelist,setPricelist]=useState([]);
    const [idToken,setIdToken]=useState("");
    const apiDomain=(process.env.NODE_ENV!=="development"?"/api":"http://"+window.location.hostname+":9000/api")
    useEffect(()=>{
        if(idToken!==""){
            getPricelist();
        }
      },[idToken])

    const getPricelist=()=>{
        if(idToken===""){return}
        const params=`/members/pricelist`;
        fetch(apiDomain+params,{"headers":{"id_token":idToken}})
        .then(res => res.text())
        .then(res => {
            const response=JSON.parse(res);
            if(response.data){
                console.log("Got pricelist: "+response.data.length+" items");
                setPricelist(response.data);
            }
        } )
        .catch((error)=>{
            console.log("error with API call");
            console.log(error);
        });

    }
    const setPricelistIdToken=((newVal)=>{
        setIdToken(newVal);
    })

    return {pricelist,setPricelistIdToken}
}

export default usePricelist;